import { Prisma } from "@prisma/client";

export const collaboratorReportingInclude =
  Prisma.validator<Prisma.UserInclude>()({
    acExpoRightsRole: {
      select: {
        name: true,
        id: true,
      },
    },
    userReporting: true,
  });

export type CollaboratorReporting = Prisma.UserGetPayload<{
  include: typeof collaboratorReportingInclude;
}>;

export type CollaboratorReportingObject = {
  name: string;
  pendingEventEmailSentCounter: number;
  aiGeneratedImageCounter: number;
  acceptedEventCounter: number;
};

export type CollaboratorReportingTotal = {
  pendingEventEmailSentCounter: number;
  aiGeneratedImageCounter: number;
  acceptedEventCounter: number;
};
